import { render, staticRenderFns } from "./StudyProgramForm.vue?vue&type=template&id=b723f5bc&scoped=true&"
import script from "./StudyProgramForm.vue?vue&type=script&lang=ts&"
export * from "./StudyProgramForm.vue?vue&type=script&lang=ts&"
import style0 from "./StudyProgramForm.vue?vue&type=style&index=0&id=b723f5bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b723f5bc",
  null
  
)

export default component.exports